import { callApi } from 'utils';
import { put } from 'redux-saga/effects';
import { setDialogDataAction } from 'components/redux-dialog/actions';
import { GENERATE_THUMBNAIL_DIALOG } from 'pages/my-videos.page/edit.page/fragments/thumbnail';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';

export function* pullThumbnailRequestEffect({ payload: { videoId, thumbnailId } }) {
  try {
    const thumbnail = yield callApi(`videos/${videoId}/thumbnail/${thumbnailId}`);
    yield put(setDialogDataAction(GENERATE_THUMBNAIL_DIALOG, thumbnail));
  } catch (error) {
    if (error.status !== 404) {
      yield put(
        reduxNotificationAction('An error happen. Please try again later.', true, 10, REDUX_NOTIFICATION_TYPES.ERROR)
      );

      yield put(
        setDialogDataAction(GENERATE_THUMBNAIL_DIALOG, {
          id: -1,
          url: `${window.__MOVINGIMAGE_CT_PUBLIC_URL}/static/img/thumbnail-not-found.png`,
        })
      );
    }
  }
}
